import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import OrderLst from "@/views/OrderLst.vue";
import StoreView from "@/views/StoreView.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/order',
        name: 'order',
        component: OrderLst
    },
    {
        path: '/store',
        name: 'store',
        component: StoreView
    },
    {
        path: "/douyin/:orderId",
        name: "douyinOrderDetails",
        component: ()=> import("@/views/DouyinSuccess.vue")
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    // document.title = ""
  next()
})

export default router
